import { useQuery } from "@tanstack/react-query"
import { whatsappOpeningMessageQuery } from "../../../lib/templates/openingMessages/whatsappOpeningMessageQuery"

export function useWhatsappOpeningMessageQuery(
  ...args: Parameters<typeof whatsappOpeningMessageQuery>
) {
  return useQuery(whatsappOpeningMessageQuery(...args))
}
